var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldKeyholeGradient = function SvgShieldKeyholeGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3187_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.452 25.8319L125.453 25.8323L129.351 27.3344L129.595 31.5199C130.349 44.4483 128.316 64.2891 119.851 83.6743C111.323 103.182 96.1342 122.484 70.5578 133.479L68.0008 134.574L65.4438 133.479C39.8674 122.484 24.6784 103.182 16.1505 83.6743L16.1504 83.6739C7.65929 64.262 5.62638 44.4223 6.40655 31.4975L6.4068 31.4933L6.65023 27.3143L10.5397 25.8355L10.5397 25.8355L10.5484 25.8322L65.6656 4.5822L65.6749 4.57855L68.0089 3.66525L70.3353 4.55531L70.3408 4.55745L125.452 25.8319ZM59.6258 93.5067V95.5067H61.6258H74.3758H76.3758V93.5067V87.1317V69.9055C81.4454 66.9963 84.8758 61.5231 84.8758 55.2567C84.8758 45.9443 77.3132 38.3817 68.0008 38.3817C58.6884 38.3817 51.1258 45.9443 51.1258 55.2567C51.1258 61.5231 54.5562 66.9963 59.6258 69.9055V87.1317V93.5067Z",
    fill: "url(#paint0_linear_3187_23208)",
    stroke: "white",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3187_23208",
    x1: 67.9964,
    y1: 1.52075,
    x2: 67.9964,
    y2: 136.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B6893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEC3CF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3187_23208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 136,
    fill: "white",
    transform: "translate(0 0.00683594)"
  })))));
};
export default SvgShieldKeyholeGradient;